export enum Slot {
  EI = 'ei',
  MC = 'mc',
}
